import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button } from '@dorixona/ui'
import { Icon } from '../../ui/Icon'

/**
 * «Заказ оформлен». Номер приходит от оформления в состоянии перехода; если
 * экран открыли ссылкой и номера нет — говорим без него, а не выдумываем.
 */
export function SuccessScreen() {
  const navigate = useNavigate()
  const { t } = useTranslation(['checkout', 'common'])
  const state = useLocation().state as { number?: number } | null
  const number = state?.number

  return (
    <section className="screen cart-wrap">
      <div className="card success">
        <div className="big">
          <Icon name="i-check" size={36} />
        </div>
        <h1>{t('checkout:success.title')}</h1>
        <p>
          {number ? t('checkout:success.body', { number }) : t('checkout:success.bodyNoNumber')}
        </p>
        <p style={{ color: 'var(--gold)', fontWeight: 600 }}>{t('checkout:success.cashback')}</p>
        <Button
          style={{ maxWidth: 280, margin: '18px auto 0' }}
          onPress={() => {
            void navigate('/')
          }}
        >
          {t('common:actions.toHome')}
        </Button>
      </div>
    </section>
  )
}
